import React from 'react';
import { Typography, Tooltip, Paper } from '@material-ui/core';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { useSelector } from 'react-redux';

import { GivingAccount } from 'generated/graphql';
import { currencyFormat, CurrencyCode } from 'utils/currencyFormat';
import { brand } from 'utils/color-styles';
import { selectUser } from 'entities/user/selectors';
import accountUSD from 'assets/budgetLedger/accountUSD.avif';
import accountEUR from 'assets/budgetLedger/accountEUR.avif';
import accountGBP from 'assets/budgetLedger/accountGBP.avif';

import { renderGivingAccountName } from './renderGivingAccountName';

const accountSVG: { [currencyCode: string]: string } = {
  USD: accountUSD as unknown as string,
  EUR: accountEUR as unknown as string,
  GBP: accountGBP as unknown as string,
};

export default function GivingAccountCard({
  givingAccount,
}: {
  givingAccount?: Pick<
    GivingAccount,
    'id' | 'currencyCode' | 'balance' | 'balanceUserCurrency' | 'provider' | 'name'
  > | null;
}): JSX.Element {
  const user = useSelector(selectUser);
  return (
    <Paper
      style={{
        color: 'white',
        padding: '24px 36px',
        flexGrow: 1,
        backgroundColor: brand,
        backgroundImage: `url("${accountSVG[givingAccount?.currencyCode || 'USD']}")`,
        backgroundSize: 'contain',
        backgroundPositionX: '90%',
        minHeight: 200,
      }}
    >
      <Typography variant="body1">
        {renderGivingAccountName(givingAccount)}
        <Tooltip title="This balance is a sum of all historical transactions, and will not change if a date range is applied to transactions.">
          <InfoIcon style={{ verticalAlign: '-20%' }} />
        </Tooltip>
      </Typography>
      <Typography
        style={{
          fontSize: 42,
          fontWeight: 'bold',
          letterSpacing: '-0.3px',
        }}
      >
        {givingAccount?.balance
          ? currencyFormat(givingAccount.balance, givingAccount.currencyCode as CurrencyCode)
          : '-'}
      </Typography>
      {user &&
        givingAccount?.balanceUserCurrency &&
        user.displayCurrency !== givingAccount?.currencyCode && (
          <Typography variant="body2">
            {currencyFormat(givingAccount.balanceUserCurrency, user.displayCurrency)}
          </Typography>
        )}
    </Paper>
  );
}
